import { useContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useEssentials } from 'hooks/utils/useEssentials'
import { LandingPageDialog } from 'components/landing-page-dialog/landingPageDialog'
import { checkRoutePermissions } from 'utils/authentication'
import { MPMLayout } from 'components/layout'
import { RemoteConfigContext } from '../firebase/FirebaseRemoteConfig.provider'

export const HomePage = () => {
    const { isAuthenticated, login, preferences, env, greenfieldGroups } =
        useEssentials()
    const {
        featureFlags: { landingPageEnabled },
        isLoading: flagsLoading,
    } = useContext(RemoteConfigContext)
    const [showDialog, setShowDialog] = useState(false)

    const isAuth = isAuthenticated()

    useEffect(() => {
        if (isAuth) {
            if (
                !greenfieldGroups ||
                !env.permissionsByKPI ||
                !preferences.user_id ||
                flagsLoading ||
                !landingPageEnabled
            ) {
                return
            }

            // If we're still here, show the dialog
            setShowDialog(true)
        } else {
            login()
        }
    }, [
        isAuth,
        login,
        greenfieldGroups,
        env.permissionsByKPI,
        preferences,
        flagsLoading,
        landingPageEnabled,
    ])

    // Check immediately during render if we should redirect
    if (
        isAuth &&
        preferences.user_id &&
        greenfieldGroups &&
        env.permissionsByKPI &&
        !flagsLoading
    ) {
        const savedLandingPage =
            preferences?.user_contexts?.[0]?.app_context?.landingPage
        // If landing page feature is disabled, always go to default
        if (!landingPageEnabled) {
            return <Navigate to="/sales/overview" replace />
        }

        if (savedLandingPage) {
            const basePath = savedLandingPage.split('/')[1]
            const hasPermission = checkRoutePermissions({
                path: `/${basePath}`,
                userPermissions: greenfieldGroups,
                permissionsByKPI: env.permissionsByKPI,
            })

            if (hasPermission) {
                // Redirect immediately - component won't fully mount
                return <Navigate to={savedLandingPage} replace />
            } else {
                // Permission denied - redirect to default
                return <Navigate to="/sales/overview" replace />
            }
        }
    }

    // Show dialog if no landing page is set, with Layout in background
    return (
        <>
            <MPMLayout heading="" isBottomNavDisplayed={false} />
            {showDialog && landingPageEnabled && (
                <LandingPageDialog isOpen={true} />
            )}
        </>
    )
}
